import { useCallback, useEffect, useRef, useState } from "react";
import { useMediaQuery } from "@mui/material";
// --------------------- Import Antd-Design ---------------------
import {
  Col,
  Flex,
  Button,
  Modal,
  Row,
  MenuProps,
  Skeleton,
  Table,
  Typography,
  message,
} from "antd";

// --------------------- Import Material Icon ---------------------
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
// --------------------- Import Styles ---------------------
import { Container } from "./styles";
// --------------------- Import Components ---------------------
import { Columns } from "./components/Columns";
import ModalAdicionar from "./components/ModalAdicionar";
import ModalUsuario from "./components/ModalUsuario";
// --------------------- Import Hooks ---------------------
import { useApartamentos } from "./hooks/useBuscarAptos";
import { useResumoCotasUsuariosEmpreendimentos } from "../../hooks/useResumoCotasUsuariosEmpreendimentos";
import type { TableProps } from "antd/es/table";
// import { useGerenciarFiltros } from "./hooks/useGerenciarFiltros";
// --------------------- Import Utéis ---------------------
import { usePermissao } from "../../uteis/permissaoAdm/usePermissao";
import { useWarning } from "../../uteis/mensagens/useWarning";
import ModalEditar from "./components/ModalEditar";
import ModalCaracteristicas from "./components/ModalCaracteristicas";
import ModalAndamentos from "./components/ModalAndamentos";
import ModalCopiar from "./components/ModalCopiar";
import { excluirApartamentoService } from "../../services/excluirApartamentoService";
import { sincronizarQtdSemanasCotasAptoService } from "../../services/sincronizarQtdSemanasCotasAptoService";
import { copiarApartamentoService } from "../../services/copiarApartamentoService";

export default function ViewGerenciarApto() {
  // Traz o estilo Title da biblioteca
  const { Title } = Typography;
  const params = new URLSearchParams(window.location.search);
  const empreendimentoIdFiltro = Number(params.get("empreendId"));
  const empreendimentoNomeFiltro = params.get("empreendNome");
  // Controle de Paginação
  const [currentPage, setCurrentPage] = useState(1);

  // Definições para mobile
  const isMobile = useMediaQuery("(max-width:600px)");

  // Armazena o valor da origem do apartamento
  const [origemApto, setOrigemApto] = useState<number | null>(null);

  // Armazena o valor do Id do apartamento
  const [apId, setApId] = useState<number | null>(null);
  const [apNome, setApNome] = useState<string | null>(null);
  const apartamentoSelecionadoRef = useRef<any>(null);

  // Definições para exibir a mensagem de alerta
  const [warning, setWarning] = useState<string | undefined>();
  const { showWarning, contextHolder } = useWarning();
  const [warningDisplayed, setWarningDisplayed] = useState(false);
  const [messageApi, messageContextHolder] = message.useMessage();

  // Busca os apartamentos
  const { apartamentos, isLoading } = useApartamentos();
  const {
    resumosPorEmpreendimento,
    isLoading: isLoadingResumoCotasUsuarios,
  } = useResumoCotasUsuariosEmpreendimentos(
    apartamentos.map((apartamento: any) => Number(apartamento.empreendId))
  );
  const apartamentosExibidos = empreendimentoIdFiltro
    ? apartamentos.filter(
        (apartamento: any) =>
          Number(apartamento.empreendId) === empreendimentoIdFiltro
      )
    : apartamentos;
  const apartamentosComResumo = apartamentosExibidos.map((apartamento: any) => {
    const resumoApartamento = resumosPorEmpreendimento[
      Number(apartamento.empreendId)
    ]?.apartamentos.find((item) => item.id === Number(apartamento.key));

    return {
      ...apartamento,
      cotasUsuarios: resumoApartamento?.totalActiveCotasUsuarios ?? 0,
    };
  });

  // Verificação de permissaão
  const { isLoading: isTokenLoading, isValid } = usePermissao("OPE");

  // Inicializando o filtro
  const [filteredInfo, setFilteredInfo] = useState<{
    empreend?: string[] | null;
    nomeAp?: string[] | null;
    origemAp?: string[] | null;
  }>({
    empreend: null,
    nomeAp: null,
    origemAp: null,
  });

  const [semFiltros, setSemFiltros] = useState(true);

  // State de abertura e fechamento do modal (Cadastrar Apartamento)
  const [isModalAdicionarOpen, setIsModalAdicionarOpen] = useState(false);

  const adicionarModal = () => {
    setIsModalAdicionarOpen(true);
  };

  const handleAdicionarFechar = () => {
    setIsModalAdicionarOpen(false);
  };

  // State de abertura e fechamento do modal (Ver proprietario)
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Funçao para abrir o modal (Ver proprietario)
  const usuarioModal = () => {
    setIsModalOpen(true);
  };

  // Funçao para fechar o modal (Ver proprietario)
  const handleFechar = () => {
    setIsModalOpen(false);
  };

  // State de abertura e fechamento do modal (Editar Apartamento)
  const [isModalEditarOpen, setIsModalEditarOpen] = useState(false);

  // Funçao para abrir o modal (Editar Apartamento)
  const editarModal = () => {
    setIsModalEditarOpen(true);
  };

  // Funçao para fechar o modal (Editar Apartamento)
  const handleEditarFechar = () => {
    setIsModalEditarOpen(false);
  };

  // State de abertura e fechamento do modal (Ver caracteristicas)
  const [isModalCaracteristicasOpen, setIsModalCaracteristicasOpen] =
    useState(false);

  const abrirModalCaracteristicas = () => {
    setIsModalCaracteristicasOpen(true);
  };

  const handleCaracteristicasFechar = () => {
    setIsModalCaracteristicasOpen(false);
  };

  const [isModalAndamentosOpen, setIsModalAndamentosOpen] = useState(false);
  const [isModalCopiarOpen, setIsModalCopiarOpen] = useState(false);
  const [isModalExcluirOpen, setIsModalExcluirOpen] = useState(false);
  const [isExcluindo, setIsExcluindo] = useState(false);
  const [empreendimentoIdCopiar, setEmpreendimentoIdCopiar] = useState<
    number | null
  >(null);

  const abrirModalAndamentos = () => {
    setIsModalAndamentosOpen(true);
  };

  const handleAndamentosFechar = () => {
    setIsModalAndamentosOpen(false);
  };

  const abrirModalCopiar = () => {
    setIsModalCopiarOpen(true);
  };

  const handleCopiarFechar = () => {
    setIsModalCopiarOpen(false);
    setEmpreendimentoIdCopiar(null);
  };

  const abrirModalExcluir = () => {
    setIsModalExcluirOpen(true);
  };

  const handleExcluirFechar = () => {
    if (!isExcluindo) {
      setIsModalExcluirOpen(false);
    }
  };

  const showSuccess = useCallback((texto: string) => {
    messageApi.open({
      type: "success",
      content: texto,
      key: "success",
    });
  }, [messageApi]);

  const showError = useCallback((texto: string) => {
    messageApi.open({
      type: "error",
      content: texto,
      key: "error",
      duration: 5,
    });
  }, [messageApi]);

  const handleCopiarSuccess = useCallback(
    (texto: string) => {
      showSuccess(texto);
      setTimeout(() => {
        window.location.reload();
      }, 1200);
    },
    [showSuccess]
  );

  const excluirApartamentoSelecionado = async () => {
    if (!apId) {
      return;
    }

    setIsExcluindo(true);

    try {
      await excluirApartamentoService(apId);
      showSuccess("Apartamento inativado com sucesso!");
      setIsModalExcluirOpen(false);
      setTimeout(() => {
        window.location.reload();
      }, 1200);
    } catch (error: any) {
      const mensagem =
        error?.message ||
        error?.erro ||
        error?.mensagem ||
        "Nao foi possivel excluir o apartamento.";

      showError(mensagem);
    } finally {
      setIsExcluindo(false);
    }
  };

  const confirmarAcertarCotas = (
    apartamentoId: number | null,
    nomeApartamento: string | null
  ) => {
    if (!apartamentoId) {
      showError("Apartamento nao encontrado.");
      return;
    }

    Modal.confirm({
      title: "Confirmar acerto de cotas?",
      content: (
        <>
          <p>
            Deseja sincronizar as cotas ativas do apartamento{" "}
            {nomeApartamento ? `"${nomeApartamento}"` : ""}?
          </p>
          <p>
            Essa acao vai ler o campo <strong>Qtd Semanas Ano</strong> do
            apartamento e sobrescrever <strong>qtdSemanas</strong> em todas as
            cotas ativas vinculadas.
          </p>
        </>
      ),
      okText: "Acertar cotas",
      cancelText: "Cancelar",
      onOk: async () => {
        try {
          const response = await sincronizarQtdSemanasCotasAptoService(
            apartamentoId
          );

          const totalAtualizadas =
            response?.totalCotasAtualizadas != null
              ? ` ${response.totalCotasAtualizadas} cota(s) atualizada(s).`
              : "";

          showSuccess(`Cotas sincronizadas com sucesso!${totalAtualizadas}`);
        } catch (error: any) {
          const mensagem =
            error?.message ||
            error?.erro ||
            error?.mensagem ||
            "Nao foi possivel acertar as cotas do apartamento.";

          showError(mensagem);
          throw error;
        }
      },
    });
  };

  const confirmarCopiarApartamento = (
    apartamentoId: number | null,
    nomeApartamento: string | null
  ) => {
    if (!apartamentoId) {
      showError("Apartamento nao encontrado.");
      return;
    }

    Modal.confirm({
      title: "Confirmar cópia do apartamento?",
      content: (
        <p>
          Deseja copiar o apartamento {nomeApartamento ? `"${nomeApartamento}"` : ""},
          incluindo suas características, cotas ativas e períodos?
        </p>
      ),
      okText: "Copiar Apto",
      cancelText: "Cancelar",
      onOk: async () => {
        try {
          const apartamentoCopiado = await copiarApartamentoService(
            apartamentoId
          );
          const nomeCopiado = apartamentoCopiado?.nome
            ? `: ${apartamentoCopiado.nome}`
            : "";

          showSuccess(`Apartamento copiado com sucesso${nomeCopiado}!`);
          setTimeout(() => {
            window.location.reload();
          }, 1200);
        } catch (error: any) {
          const mensagem =
            error?.message ||
            error?.erro ||
            error?.mensagem ||
            "Nao foi possivel copiar o apartamento.";

          showError(mensagem);
          throw error;
        }
      },
    });
  };

  // ------------------------------  ---------------------------

  // OnClick das opções e funções que serão realizadas do item Ações
  const onClick: MenuProps["onClick"] = async ({ key }) => {
    const apartamentoSelecionado = apartamentoSelecionadoRef.current;

    switch (key) {
      // Ver Cotas
      case "1":
        window.location.href = `/gerenciarCotas/?aptoId=${
          apartamentoSelecionado?.key
        }&&aptoNome=${apartamentoSelecionado?.nome}&&empreendNome=${
          apartamentoSelecionado?.empreendimento
        }&&empreendId=${apartamentoSelecionado?.empreendId ?? ""}`;
        break;

      // Copiar
      case "7":
        setApId(apartamentoSelecionado?.key ?? null);
        setApNome(apartamentoSelecionado?.nome ?? null);
        setEmpreendimentoIdCopiar(
          apartamentoSelecionado?.empreendId
            ? Number(apartamentoSelecionado.empreendId)
            : null
        );
        abrirModalCopiar();
        break;

      // Acertar cotas
      case "8":
        confirmarAcertarCotas(
          apartamentoSelecionado?.key
            ? Number(apartamentoSelecionado.key)
            : null,
          apartamentoSelecionado?.nome ?? null
        );
        break;

      // Copiar apartamento
      case "9":
        confirmarCopiarApartamento(
          apartamentoSelecionado?.key
            ? Number(apartamentoSelecionado.key)
            : null,
          apartamentoSelecionado?.nome ?? null
        );
        break;

      // Editar Apartamento
      case "2":
        setApId(apartamentoSelecionado?.key ?? null);
        setApNome(apartamentoSelecionado?.nome ?? null);
        editarModal();
        break;

      // Ver Proprietário
      case "3":
        if (apartamentoSelecionado?.origemApto === 0) {
          setWarning("Propriedade Multicotas");
        } else {
          setOrigemApto(apartamentoSelecionado?.origemApto ?? null);
          usuarioModal();
        }
        break;

      // Ver Caracteristicas
      case "4":
        setApId(apartamentoSelecionado?.key ?? null);
        setApNome(apartamentoSelecionado?.nome ?? null);
        abrirModalCaracteristicas();
        break;

      // Ver Andamentos
      case "5":
        setApId(apartamentoSelecionado?.key ?? null);
        setApNome(apartamentoSelecionado?.nome ?? null);
        abrirModalAndamentos();
        break;

      // Excluir
      case "6":
        setApId(apartamentoSelecionado?.key ?? null);
        setApNome(apartamentoSelecionado?.nome ?? null);
        abrirModalExcluir();
        break;
    }
  };
  const selecionarApartamento = (apartamento: any) => {
    apartamentoSelecionadoRef.current = apartamento;
  };
  // Traz as informações  OnClick, origem , nome e id do apartamento além do nome do empreendimento, ao clickar na linha especifica
  const columns = Columns(
    onClick,
    selecionarApartamento,
    {
      empreend: filteredInfo.empreend,
      nomeAp: filteredInfo.nomeAp,
      origemAp: filteredInfo.origemAp,
    }
  );

  // useEffect para lidar com a mensagem
  useEffect(() => {
    if (warning && !warningDisplayed) {
      // Verifica se a mensagem já foi exibida
      showWarning(warning);
      setWarningDisplayed(true);
    }

    // Limpa o estado de mensagem
    setTimeout(() => {
      setWarningDisplayed(false);
      setWarning(undefined);
    }, 3000);
  }, [showWarning, warningDisplayed, warning]);

  useEffect(() => {
    const filtros = localStorage.getItem("filtrosPropriedades");
    const pagina = localStorage.getItem("pageGerPropriedades");

    if (empreendimentoIdFiltro) {
      setFilteredInfo({
        empreend: null,
        nomeAp: null,
        origemAp: null,
      });
      setSemFiltros(true);
      setCurrentPage(1);
      return;
    }

    if (filtros) {
      const novoFiltro = JSON.parse(filtros);
      setFilteredInfo({
        empreend: novoFiltro.empreendimento
          ? [novoFiltro.empreendimento]
          : null,
        nomeAp: novoFiltro.nome ? [novoFiltro.nome] : null,
        origemAp: novoFiltro.origem ? [novoFiltro.origem] : null,
      });
      setSemFiltros(false);
    }

    if (pagina) {
      setCurrentPage(Number(pagina));
    }
  }, [empreendimentoIdFiltro]);

  const onChange: TableProps<any>["onChange"] = (pagination, filters) => {
    setFilteredInfo({
      empreend: filters.empreendimento as string[] | null,
      nomeAp: filters.nome as string[] | null,
      origemAp: filters.origem as string[] | null,
    });

    const hasFilters = Boolean(
      filters.empreendimento || filters.nome || filters.origem
    );
    setSemFiltros(!hasFilters);

    if (pagination.current) {
      localStorage.setItem(
        "pageGerPropriedades",
        pagination.current.toString()
      );
    }

    localStorage.setItem("filtrosPropriedades", JSON.stringify(filters));
  };

  const removerFiltros = () => {
    localStorage.removeItem("filtrosPropriedades");
    localStorage.removeItem("pageGerPropriedades");

    setFilteredInfo({ empreend: null, nomeAp: null, origemAp: null });
    setSemFiltros(true);
    setCurrentPage(1);
  };

  const handleFilter = () => {
    removerFiltros();
  };

  return (
    <>
      {(isLoading || isLoadingResumoCotasUsuarios || isTokenLoading) ||
      !isValid ? (
        <Skeleton active />
      ) : (
        <Container>
          <>{contextHolder}</>
          <>{messageContextHolder}</>
          <Row>
            <Col span={5}>
              <Flex align="center" justify="center" style={{ marginTop: 15 }}>
                <a href={`/gerenciarEmpreendimento`}>
                  <ArrowBackIcon color="primary" />
                </a>
              </Flex>
            </Col>
            <Col span={12}>
              <Flex align="center" justify="center">
                <HomeIcon color="primary" fontSize="large" />

                <Title
                  style={{
                    marginLeft: 10,
                    marginTop: 10,
                    fontSize: isMobile ? "1rem" : "2rem",
                    color: "rgb(0, 54, 68)",
                  }}
                  level={3}
                >
                  Gerenciar Apartamentos
                </Title>
              </Flex>
            </Col>
          </Row>
          <Row>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                height: "auto",
                width: "90%",
                gap: "20px",
              }}
            >
              <div style={{ display: "flex", gap: "20px" }}>
                <Button onClick={adicionarModal} type="primary">
                  + Apartamento
                </Button>
                {semFiltros ? (
                  <Button onClick={handleFilter} type="primary" disabled>
                    <FilterAltIcon />
                  </Button>
                ) : (
                  <Button onClick={handleFilter} type="primary">
                    <FilterAltOffIcon />
                  </Button>
                )}
              </div>
            </div>
            {empreendimentoNomeFiltro && (
              <Col span={24} style={{ marginLeft: 50, marginBottom: 10 }}>
                <strong>
                  Listando apartamentos de:{" "}
                  {empreendimentoNomeFiltro}
                </strong>
              </Col>
            )}
            <Col span={isMobile ? 5 : 1}></Col>
            <Col
              span={22}
              style={{
                marginTop: isMobile ? 15 : 20,
                marginBottom: isMobile ? 30 : 50,
              }}
            >
              <Flex
                style={{
                  width: isMobile ? "auto" : "100%",
                  overflow: "auto",
                  marginLeft: 0,
                }}
              >
                <Table
                  columns={columns}
                  dataSource={apartamentosComResumo}
                  onChange={onChange}
                  bordered
                  tableLayout="fixed"
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    width: isMobile ? "auto" : "100%",
                    maxWidth: isMobile ? "none" : "100%",
                  }}
                  pagination={{ defaultCurrent: currentPage }}
                />
              </Flex>
            </Col>
            <Col span={1}></Col>
          </Row>
          <ModalUsuario
            isModalOpen={isModalOpen}
            handleFechar={handleFechar}
            origemApto={origemApto}
          />
          <ModalEditar
            isModalOpen={isModalEditarOpen}
            handleFechar={handleEditarFechar}
            aptoId={apId}
          />
          <ModalCaracteristicas
            isModalOpen={isModalCaracteristicasOpen}
            handleFechar={handleCaracteristicasFechar}
            aptoId={apId}
          />
          <ModalAndamentos
            isModalOpen={isModalAndamentosOpen}
            handleFechar={handleAndamentosFechar}
            apartamentoId={apId}
            apartamentoNome={apNome}
          />
          <ModalCopiar
            isModalOpen={isModalCopiarOpen}
            handleFechar={handleCopiarFechar}
            aptoDestinoId={apId}
            aptoDestinoNome={apNome}
            empreendimentoId={empreendimentoIdCopiar}
            onSuccess={handleCopiarSuccess}
            onError={showError}
          />
          <Modal
            open={isModalExcluirOpen}
            onCancel={handleExcluirFechar}
            onOk={excluirApartamentoSelecionado}
            okText="Excluir"
            cancelText="Cancelar"
            confirmLoading={isExcluindo}
            okButtonProps={{ danger: true }}
          >
            <Title level={4}>Confirmar exclusao?</Title>
            <p>
              Deseja inativar o apartamento {apNome ? `"${apNome}"` : ""}?
            </p>
            <p>
              As cotas e periodos vinculados tambem serao inativados, caso nao
              exista bloqueio por vinculos ativos.
            </p>
          </Modal>
          <ModalAdicionar
            isModalOpen={isModalAdicionarOpen}
            handleFechar={handleAdicionarFechar}
            empreendimentoInicialId={empreendimentoIdFiltro || null}
          />
        </Container>
      )}
      ;
    </>
  );
}
